import styled, { keyframes } from 'styled-components'
import { Button, Theme } from '@web-apps/ui-shared'

export const StyledActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 4;
  position: fixed;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 720px;
  padding: 24px;
  background-color: ${Theme.Colors.background.base};
  box-shadow: 0 -4px 32px 8px ${Theme.Colors.background.halfTransparent};
  border-radius: 8px 8px 0 0;
`

const topBubbles = keyframes`
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0 80%, 0 20%, 10% 40%, 20% 0, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0 70%, 0 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

const bottomBubbles = keyframes`
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0;
  }
  50% {
    background-position: 0 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0;
  }
  100% {
    background-position: 0 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
    background-size: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  }
`

export const StyledPreviousThemeButton = styled(Button)`
  padding: 4px;
  margin: 8px 8px 8px 0;
  border: 1px solid ${Theme.Colors.line};
  border-radius: 8px;

  &:disabled {
    background-color: rgba(51, 51, 51, 0.04);
    cursor: not-allowed;

    svg,
    path {
      fill: rgba(51, 51, 51, 0.32);
    }
  }
`

export const StyledGenerateThemeButton = styled(Button)<{
  $showAnimation: boolean
}>`
  flex: 1;
  border-color: ${Theme.Colors.line};
  appearance: none;
  transition: transform ease-in 0.1s, box-shadow ease-in 0.25s;

  &:focus {
    outline: 0;
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    display: block;
    width: 140%;
    height: 100%;
    left: -20%;
    z-index: -1000;
    transition: all ease-in-out 0.5s;
    background-repeat: no-repeat;
  }

  &:before {
    display: ${({ $showAnimation }) => ($showAnimation ? 'block' : 'none')};
    top: -75%;
    background-image: radial-gradient(circle, #efa490 20%, transparent 20%),
      radial-gradient(circle, transparent 20%, #efa490 20%, transparent 30%),
      radial-gradient(circle, #efa490 20%, transparent 20%),
      radial-gradient(circle, #d0fb54 20%, transparent 20%),
      radial-gradient(circle, transparent 10%, #d0fb54 15%, transparent 20%),
      radial-gradient(circle, #d0fb54 20%, transparent 20%),
      radial-gradient(circle, #89c1f4 20%, transparent 20%),
      radial-gradient(circle, #89c1f4 20%, transparent 20%),
      radial-gradient(circle, #89c1f4 20%, transparent 20%);
    background-size: 24px 24px, 40px 40px, 32px 32px, 40px 40px, 32px 32px,
      16px 16px, 32px 32px, 16px 16px, 32px 32px;
    animation: ${topBubbles} ease-in-out 0.75s forwards;
  }

  &:after {
    display: ${({ $showAnimation }) => ($showAnimation ? 'block' : 'none')};
    bottom: -75%;
    background-image: radial-gradient(circle, #89c1f4 20%, transparent 20%),
      radial-gradient(circle, #89c1f4 20%, transparent 20%),
      radial-gradient(circle, transparent 10%, #efa490 15%, transparent 20%),
      radial-gradient(circle, #efa490 20%, transparent 20%),
      radial-gradient(circle, #d0fb54 20%, transparent 20%),
      radial-gradient(circle, #d0fb54 20%, transparent 20%),
      radial-gradient(circle, #d0fb54 20%, transparent 20%);
    background-size: 32px 32px, 40px 40px, 32px 32px, 40px 40px, 32px 32px,
      16px 16px, 40px 40px;
    animation: ${bottomBubbles} ease-in-out 0.75s forwards;
  }

  &:active {
    transform: scale(0.9);
    background-color: darken(#fff, 5%);
    box-shadow: 0 2px 25px rgba(0, 0, 0, 0.2);
  }
`
